import OverallSurvivabilityChart from './OverallSurvivabilityChart.react';

export default OverallSurvivabilityChart;